import { Components } from '@/api/generated/api';
import { UserRoleType } from '@/api/generated/api.enum';

export const hasRole = (
  userRole: Components.Schemas.UserRoleWithTenantDto,
  role: Components.Schemas.UserRoleType,
): boolean => {
  return userRole.roleType === role;
};

export const getCurrentTenant = (
  whoAmI?: Components.Schemas.WhoAmIDataDto | null,
): Components.Schemas.TenantDto | undefined => {
  return whoAmI?.userRoles.find((role) => role.tenant.id === whoAmI.currentTenantId)?.tenant;
};

export const getCurrentRole = (
  whoAmI?: Components.Schemas.WhoAmIDataDto | null,
): Components.Schemas.UserRoleWithTenantMetaDataDto | undefined => {
  return whoAmI?.userRoles.find((role) => role.tenant.id === whoAmI.currentTenantId);
};

export const getIsCurrentTenantSingleUser = (whoAmI?: Components.Schemas.WhoAmIDataDto | null): boolean => {
  return getCurrentRole(whoAmI)?.isSingleUserTenant ?? false;
};

export const getHasProviderAccess = (whoAmI?: Components.Schemas.WhoAmIDataDto | null): boolean => {
  if (!whoAmI) return false;
  const currentTenant = getCurrentTenant(whoAmI);
  return currentTenant?.isProvider ?? false;
};

export const getHasTenantAdminAccess = (whoAmI?: Components.Schemas.WhoAmIDataDto | null): boolean => {
  if (!whoAmI) return false;
  const currentRole = getCurrentRole(whoAmI);
  return !!currentRole && (hasRole(currentRole, UserRoleType.owner) || hasRole(currentRole, UserRoleType.admin));
};

export const getHasTenantOwnerAccess = (whoAmI?: Components.Schemas.WhoAmIDataDto | null): boolean => {
  if (!whoAmI) return false;
  const currentRole = getCurrentRole(whoAmI);
  return !!currentRole && hasRole(currentRole, UserRoleType.owner);
};

export const isClassAccessRole = (roleType?: Components.Schemas.UserRoleType | null): boolean => {
  return roleType === UserRoleType.user || roleType === UserRoleType.external;
};

export const getNewestUserRole = (
  whoAmI: Components.Schemas.WhoAmIDataDto | null,
): Components.Schemas.UserRoleWithTenantMetaDataDto | null => {
  const userRoles = whoAmI?.userRoles;
  if (!userRoles?.length) return null;

  return [...userRoles].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0];
};

export const getTenantMembershipLabel = ({
  tenantName,
  roleLabel,
  isSingleUserTenant,
}: {
  tenantName: string;
  roleLabel: string;
  isSingleUserTenant: boolean;
}): string => {
  return isSingleUserTenant ? tenantName : `${roleLabel} (${tenantName})`;
};

export const getOwnerSubscriptionDescription = ({
  ownerRoleDescription,
  ownerStatusDescription,
  isSingleUserTenant,
}: {
  ownerRoleDescription: string;
  ownerStatusDescription: string;
  isSingleUserTenant: boolean;
}): string => {
  return isSingleUserTenant ? ownerStatusDescription : `${ownerRoleDescription} ${ownerStatusDescription}`;
};
